module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "cube-toast-fade"
    }
  }, [_c('cube-popup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    attrs: {
      "type": "toast",
      "z-index": _vm.zIndex,
      "mask": _vm.mask
    },
    on: {
      "mask-click": _vm.maskClick
    }
  }, [(!_vm.isLoading && _vm.iconClass.length) ? _c('i', {
    staticClass: "cube-toast-icon",
    class: _vm.iconClass
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('cube-loading') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.txt),
      expression: "txt"
    }],
    staticClass: "cube-toast-tip",
    domProps: {
      "innerHTML": _vm._s(_vm.txt)
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48a262c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/cube-ui/src/components/toast/toast.vue
// module id = 459
// module chunks = 3 5